const Home = () => import('../pages/home').then(m => m.default || m)
const Trck = () => import('../pages/trck').then(m => m.default || m)
const Access = () => import('../pages/access').then(m => m.default || m)
const processCallback = () => import('../pages/processCallback').then(m => m.default || m)

const Login = () => import('../pages/auth/login').then(m => m.default || m)
const PasswordReset = () => import('../pages/auth/password/reset').then(m => m.default || m)
const PasswordRequest = () => import('../pages/auth/password/email').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('../pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('../pages/settings/password').then(m => m.default || m)
const SettingsSubscriptions = () => import('../pages/settings/subscriptions').then(m => m.default || m)
const SettingsFavourites = () => import('../pages/settings/favourites').then(m => m.default || m)

const HealthyFoodIndex = () => import('../pages/healthyfood/index').then(m => m.default || m)
const HealthyFoodList = () => import('../pages/healthyfood/list').then(m => m.default || m)
const HealthyFoodShow = () => import('../pages/healthyfood/show').then(m => m.default || m)

const TipIndex = () => import('../pages/tips/index').then(m => m.default || m)
const TipList = () => import('../pages/tips/list').then(m => m.default || m)
const TipShow = () => import('../pages/tips/show').then(m => m.default || m)

const fitIndex = () => import('../pages/fit/index').then(m => m.default || m)
const lessonIndex = () => import('../pages/lessons/index').then(m => m.default || m)
const lessonList = () => import('../pages/lessons/list').then(m => m.default || m)
const lessonPreview = () => import('../pages/lessons/preview').then(m => m.default || m)

const trainingIndex = () => import('../pages/training/index').then(m => m.default || m)
// const trainingShow = () => import('../pages/training/show').then(m => m.default || m)
const trainingPreview = () => import('../pages/training/preview').then(m => m.default || m)
const trainingList = () => import('../pages/training/list').then(m => m.default || m)

const eventsIndex = () => import('../pages/events/index').then(m => m.default || m)

// const programsIndex = () => import('../pages/programs/index').then(m => m.default || m)
// const programsSorir = () => import('../pages/programs/sorir').then(m => m.default || m)
// const programsPercurso = () => import('../pages/programs/ride').then(m => m.default || m)
// const programsPercursoDetail = () => import('../pages/programs/ride-detail').then(m => m.default || m)
// const programsResumoTv = () => import('../pages/programs/tvsummary').then(m => m.default || m)
// const programsFinalistas = () => import('../pages/programs/finalists').then(m => m.default || m)
// const programsFinalistasDetail = () => import('../pages/programs/finalist-detail').then(m => m.default || m)
// const programsCalendario = () => import('../pages/programs/calendar').then(m => m.default || m)
// const programsShow = () => import('../pages/programs/show').then(m => m.default || m)

const galleryIndex = () => import('../pages/gallery/index').then(m => m.default || m)
const galleryList = () => import('../pages/gallery/list').then(m => m.default || m)
const videosIndex = () => import('../pages/videos/index').then(m => m.default || m)
const videosShow = () => import('../pages/videos/show').then(m => m.default || m)


const TEC = () => import('../pages/tec/index').then(m => m.default || m)
const Results = () => import('../pages/results/index').then(m => m.default || m)
const Passatempos = () => import('../pages/results/passatempo').then(m => m.default || m)
const ContestShow = () => import('../pages/results/show').then(m => m.default || m)
const Regulation = () => import('../pages/regulation/index').then(m => m.default || m)
const ContactUs = () => import('../pages/contact/index').then(m => m.default || m)


export default [
    {path: '/', name: 'home', component: Home},
    {path: '/trck', name: 'trck', component: Trck},
    {path: '/access/:subscriptionId', name: 'access', component: Access},
    {path: '/subscription/process/:guard/:redirect', name: 'processCallback', component: processCallback},
    {path: '/subscription/process/:guard', name: 'processCallback', component: processCallback},

    {path: '/login', name: 'login', component: Login},
    {path: '/password/reset', name: 'password.request', component: PasswordRequest},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

    {
        path: '/settings', component: Settings, children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {path: 'password', name: 'settings.password', component: SettingsPassword},
        ]
    },

    {path: '/vida-saudavel', name: 'life.index', component: HealthyFoodIndex},
    {path: '/vida-saudavel/:slug', name: 'life.list', component: HealthyFoodList},
    {path: '/vida-saudavel/:slug', name: 'life.show', component: HealthyFoodShow},

    {path: '/dicas', name: 'recipe.index', component: TipIndex},
    {path: '/dicas/:slug', name: 'recipe.list', component: TipList},
    {path: '/dica/:slug', name: 'recipe.show', component: TipShow},

    {path: '/treinadores', name: 'trainer.index', component: trainingIndex},
    {path: '/fit-power', name: 'fit.index', component: fitIndex},
    {path: '/treinos-power', name: 'training.index', component: trainingIndex},
    {path: '/treinos-power/:slug', name: 'training.show', component: trainingIndex},
    {path: '/treinos-power/:trainer/:day', name: 'training.perday', component: trainingList},
    {path: '/treino/:slug', name: 'training.preview', component: trainingPreview},

    {path: '/aulas-power', name: 'aulas.index', component: lessonIndex},
    {path: '/aulas-power/:slug', name: 'aulas.show', component: lessonList},
    {path: '/aula/:slug', name: 'aula.preview', component: lessonPreview},

    {path: '/eventos', name: 'event.index', component: eventsIndex},
    // {path: '/programa', name: 'programs.index', component: programsIndex},
    // {path: '/programa/sorir', name: 'programs.sorir', component: programsSorir},
    // {path: '/programa/percurso', name: 'programs.ride', component: programsPercurso},
    // {path: '/programa/percurso/:slug', name: 'programs.rideshow', component: programsPercursoDetail},
    // {path: '/programa/resumotv', name: 'programs.summary', component: programsResumoTv},
    // {path: '/programa/finalistas', name: 'programs.finalists', component: programsFinalistas},
    // {path: '/programa/finalistas/:slug', name: 'programs.finalistsshow', component: programsFinalistasDetail},
    // {path: '/programa/calendario', name: 'programs.calendar', component: programsCalendario},
    // {path: '/programa/:slug', name: 'programs.show', component: programsShow},

    {path: '/galeria', name: 'galleries.index', component: galleryIndex},
    {path: '/galeria/:slug', name: 'galleries.list', component: galleryList},
    {path: '/videos', name: 'videos.index', component: videosIndex},
    {path: '/videos/:slug', name: 'videos.show', component: videosShow},


    {path: '/profile', name: 'profile', component: SettingsProfile},
    {path: '/subscriptions', name: 'subscriptions', component: SettingsSubscriptions},
    {path: '/favourites', name: 'favourites', component: SettingsFavourites},

    {path: '/passatempos', name: 'contests', component: Passatempos},
    {path: '/passatempos/:slug', name: 'contest.show', component: ContestShow},
    {path: '/pages/tec', name: 'tec', component: TEC},
    {path: '/pages/results', name: 'results', component: Results},
    {path: '/pages/regulation', name: 'regulation', component: Regulation},
    {path: '/pages/contact', name: 'contact-us', component: ContactUs},

    {path: '*', name: '404', component: require('../pages/errors/404.vue')}
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js